export default function pad(num, size = 4) {
  let s = num + ''
  while (s.length < size) s = '0' + s
  return s
}



// WEBPACK FOOTER //
// ./helpers/pad.js